import { MapUiTheme } from '../../common';
import { padding } from '../../common/theme/utils';

export const buttonTheme = {
  defaultStyles: {
    fontSize: (theme: MapUiTheme) => theme.fontSize.base,
    outline: 'none',
    border: 'none',
    borderRadius: (theme: MapUiTheme) => theme.borderRadius.lg,
    borderColor: 'none',
    borderStyle: 'solid',
    fontWeight: 'bold',
    cursor: 'pointer',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: (theme: MapUiTheme) => theme.lineHeight.snug,
    borderWidth: '1px',
    backgroundColor: 'initial',
    boxShadow: 'none',
    margin: '0',
    position: 'relative',

    '&:hover, &:focus': {
      textDecoration: 'none',
    },
    '&:disabled': {
      cursor: 'not-allowed',
    },
  },
  xs: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['2'],
      (theme: MapUiTheme) => theme.spacing['4']
    ),
    fontSize: (theme: MapUiTheme) => theme.fontSize.sm,
  },
  sm: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['2'],
      (theme: MapUiTheme) => theme.spacing['6']
    ),
    fontSize: (theme: MapUiTheme) => theme.fontSize.sm,
  },
  md: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['3'],
      (theme: MapUiTheme) => theme.spacing['6']
    ),
    fontSize: (theme: MapUiTheme) => theme.fontSize.sm,
  },
  lg: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['4'],
      (theme: MapUiTheme) => theme.spacing['6']
    ),
    fontSize: (theme: MapUiTheme) => theme.fontSize.base,
  },
  xl: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['5'],
      (theme: MapUiTheme) => theme.spacing['6']
    ),
    fontSize: (theme: MapUiTheme) => theme.fontSize.base,
  },
  primary: {
    backgroundColor: (theme: MapUiTheme) => theme.colors.text300,
    borderRadius: (theme: MapUiTheme) => theme.borderRadius.lg,
    borderColor: (theme: MapUiTheme) => theme.colors.text300,
    borderWidth: '1px',
    color: (theme: MapUiTheme) => theme.colors.white,
    margin: '0',

    '&:hover, &:focus': {
      backgroundColor: (theme: MapUiTheme) => theme.colors.neutral500,
      borderColor: (theme: MapUiTheme) => theme.colors.neutral500,
      color: (theme: MapUiTheme) => theme.colors.white,
    },
    '&:active': {
      backgroundColor: (theme: MapUiTheme) => theme.colors.text400,
      borderColor: (theme: MapUiTheme) => theme.colors.text400,
    },
    '&:disabled': {
      backgroundColor: (theme: MapUiTheme) => theme.colors.grey300,
      borderColor: (theme: MapUiTheme) => theme.colors.grey300,
      color: (theme: MapUiTheme) => theme.colors.neutral400,
    },
  },
  secondary: {
    backgroundColor: (theme: MapUiTheme) => theme.colors.white,
    color: (theme: MapUiTheme) => theme.colors.text300,
    borderColor: (theme: MapUiTheme) => theme.colors.text300,
    borderRadius: (theme: MapUiTheme) => theme.borderRadius.lg,
    borderWidth: '1px',
    boxShadow: 'none',
    margin: '0',

    '&:hover, &:focus': {
      backgroundColor: (theme: MapUiTheme) => theme.colors.text300,
      borderColor: (theme: MapUiTheme) => theme.colors.text300,
      color: (theme: MapUiTheme) => theme.colors.white,
    },
    '&:active': {
      backgroundColor: (theme: MapUiTheme) => theme.colors.text400,
      borderColor: (theme: MapUiTheme) => theme.colors.text400,
      color: (theme: MapUiTheme) => theme.colors.white,
    },
    '&:disabled': {
      backgroundColor: (theme: MapUiTheme) => theme.colors.white,
      color: (theme: MapUiTheme) => theme.colors.neutral100,
      borderColor: (theme: MapUiTheme) => theme.colors.neutral100,
    },
  },
  accent: {
    backgroundColor: (theme: MapUiTheme) => theme.colors.interaction200,
    borderColor: (theme: MapUiTheme) => theme.colors.interaction200,
    color: (theme: MapUiTheme) => theme.colors.text300,
    borderRadius: (theme: MapUiTheme) => theme.borderRadius.lg,
    borderWidth: '1px',
    margin: '0',

    '&:hover, &:focus': {
      backgroundColor: (theme: MapUiTheme) => theme.colors.interaction100,
      borderColor: (theme: MapUiTheme) => theme.colors.interaction100,
      color: (theme: MapUiTheme) => theme.colors.text300,
    },
    '&:active': {
      backgroundColor: (theme: MapUiTheme) => theme.colors.interaction300,
      borderColor: (theme: MapUiTheme) => theme.colors.interaction300,
      color: (theme: MapUiTheme) => theme.colors.text300,
    },
    '&:disabled': {
      backgroundColor: (theme: MapUiTheme) => theme.colors.neutral100,
      borderColor: (theme: MapUiTheme) => theme.colors.neutral100,
      color: (theme: MapUiTheme) => theme.colors.neutral400,
    },
  },
  unstyled: {
    backgroundColor: 'transparent',
    border: 'none',
    color: (theme: MapUiTheme) => theme.global.body.color,
    '&:hover, &:focus': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    '&:active': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    '&:disabled': {
      color: (theme: MapUiTheme) => theme.colors.neutral400,
    },
  },
  success: {
    backgroundColor: (theme: MapUiTheme) => theme.colors.success300,
    borderColor: (theme: MapUiTheme) => theme.colors.success300,
    color: (theme: MapUiTheme) => theme.colors.white,
  },
  error: {
    backgroundColor: (theme: MapUiTheme) => theme.colors.danger300,
    borderColor: (theme: MapUiTheme) => theme.colors.danger300,
    color: (theme: MapUiTheme) => theme.colors.white,
  },
};
